import { IPermission } from '@publishing-engine/domain/models';
import { getRoleConfigValidator } from '@publishing-engine/domain/validation';

/** Payload sent to the create and update workspace role endpoints. */
export type IRolePayload = {
  name: string;
  displayName: string;
  permissions: IPermission;
};

/**
 * Role form state: the payload plus the per-phase radio selection. Phases the
 * user leaves untouched are absent from `permissionsGroup` until submit, when
 * buildPhasePermissions folds the remaining ones into `permissions`.
 */
export type IRoleFormData = IRolePayload & {
  permissionsGroup?: IPermission;
};

/** Role form validation rules, shared with the submission service. */
export const roleFormSchema = getRoleConfigValidator('frontend');
